// extracted by mini-css-extract-plugin
module.exports = {"icon":"InputError_icon__2rrTt","text":"InputError_text__CuAzC","error":"InputError_error__GzmH6"};